import { LIQUIDATION_CURSOR, MathLib, MAX_LIQUIDATION_INCENTIVE_FACTOR } from '@morpho-org/blue-sdk'

/**
 * Calculates the liquidation incentive factor based on loan-to-value ratio.
 * @param lltv - Loan-to-value ratio in WAD format (18 decimals)
 * @returns Incentive factor in WAD format
 * @see https://docs.morpho.org/morpho/concepts/liquidation/
 */
export const getIncentiveFactor = (lltv: bigint) => {
  return MathLib.min(
    MAX_LIQUIDATION_INCENTIVE_FACTOR,
    MathLib.wDivDown(
      MathLib.WAD,
      MathLib.WAD - MathLib.wMulDown(LIQUIDATION_CURSOR, MathLib.WAD - lltv)
    )
  )
}

/**
 * Calculates the liquidation penalty percentage from loan-to-value ratio.
 * Penalty is the incentive factor minus 1 (WAD).
 * @param lltv - Loan-to-value ratio in WAD format (18 decimals)
 * @returns Penalty percentage in WAD format
 */
export const getLiquidationPenalty = (lltv: bigint) => {
  return getIncentiveFactor(lltv) - MathLib.WAD
}
